import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import noop from 'lodash';

import { Label, Icon } from 'shared/components';
import { ASTERISK, OPTIONAL, REQUIRED } from 'shared/components/_constants/label';
import requestsStatuses from 'modules/common/constants/requestsStatuses';

import theme from './RadioGroup.scss';
import HintQuestion from '../HintQuestion/HintQuestion';

class RadioGroup extends Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.object,
    labelSuffix: PropTypes.oneOfType([
      PropTypes.oneOf([ASTERISK, OPTIONAL, REQUIRED]),
      PropTypes.node,
    ]),
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    name: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.object,
    })).isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    status: PropTypes.oneOf([
      requestsStatuses.default,
      requestsStatuses.failure,
      requestsStatuses.pending,
      requestsStatuses.success,
    ]),
    labelSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isMobile: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    label: null,
    labelSuffix: null,
    value: null,
    defaultValue: null,
    disabled: false,
    status: requestsStatuses.default,
    labelSize: null,
    isMobile: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.defaultValue || props.value || null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.selectedValue) {
      this.setState({ selectedValue: nextProps.value });
    }
  }

  onChange = (e) => {
    this.setState({ selectedValue: e.target.value });

    this.props.onChange(e.target.value);
  };

  radioRenderer = () => {
    const { name, items, className, status } = this.props;

    return (
      <div className={ classnames(className) }>
        { items.map((item) => (
          <div
            className={ theme.item }
            key={ `key-${ item.key.toLowerCase() }` }
          >
            <label
              className={ classnames(theme.itemLabel, {
                [theme.disabled]: this.props.disabled || item.disabled,
                [theme[status.toLowerCase()]]: status.toLowerCase(),
              }) }

            >
              <div
                data-testid={ `${ item.key.toLowerCase() }-radio-field` }
                className={ classnames(theme.iconContainer, {
                  [theme.checked]: this.state.selectedValue === item.key,
                }) }
              />

              <input
                type="radio"
                name={ name }
                value={ item.key }
                checked={ this.state.selectedValue === item.key }
                onChange={ (this.props.disabled || item.disabled) ? noop : this.onChange }
              />

              <FormattedMessage { ...item.label } />

              <If condition={ item.icon }>
                <Icon name={ item.icon } className={ theme.icon } />
              </If>

            </label>
            <If condition={ item.hint }>
              <HintQuestion
                className={ theme.iconQuestion }
                tooltipMessage={ item.hint }
              />
            </If>
          </div>
        )) }
      </div>
    );
  };

  render() {
    const { label, labelSuffix, isMobile } = this.props;

    if (label) {
      return (
        <div>
          <Label
            label={ label }
            className={ theme.label }
            labelSuffix={ labelSuffix }
            isMobile={ isMobile }
          />

          { this.radioRenderer() }
        </div>
      );
    }

    return this.radioRenderer();
  }
}

export default RadioGroup;
